const WorkPermitCards = ({ rows = [] }) => {
    const formattedRows = rows || [];

    return (
        <div className="card-table-container flex flex-col gap-[15px] md:hidden mt-[15px]">
            {formattedRows.length === 0 ? (
                <p className="info-text text-center">No work permits found</p>
            ) : (
                formattedRows.map((row, idx) => (
                    <div
                        key={row._id || idx}
                        className="border border-gray-300 rounded-lg p-6 w-full"
                    >
                        <div className="detail-row -mt-[10px] mb-2">
                            <div className="detail-column">
                                <p className="detail-label">Unit</p>
                                <p className="detail">{row.unit?.unitNumber || 'N/A'}</p>
                            </div>
                            <div className="detail-column">
                                <p className="detail-label">Status</p>
                                <p className="detail">                            
                                    <span className={`request-status-badge ${row.status?.toLowerCase()}`} style={{ display: 'flex', justifyContent: 'center' }}>
                                        {row.status}
                                    </span>
                                </p>
                            </div>
                            </div>
                        <div className="detail-row -mt-[10px]">
                            <div className="detail-column">
                                <p className="detail-label">Service Provider</p>
                                <p className="detail">{row.details?.serviceProvider}</p>
                            </div>
                            <div className="detail-column">
                                <p className="detail-label">Work Category</p>
                                <p className="detail">{row.details?.workCategory}</p>
                            </div>
                        </div>
                        <div className="detail-row -mt-[10px]">
                            <div className="detail-column">
                                <p className="detail-label">Start Date</p>
                                <p className="detail">{new Date(row.details?.startDate).toLocaleDateString()}</p>
                            </div>
                            <div className="detail-column">
                                <p className="detail-label">End Date</p>
                                <p className="detail">{new Date(row.details?.endDate).toLocaleDateString()}</p>
                            </div>
                        </div>
                        <div className="detail-column">
                            <p className="detail-label">Description</p>
                            <p className="detail">
                                {row.description || 'N/A'}
                            </p>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default WorkPermitCards;
